import { Expenses1 } from "../../_components/Imagepath";

export default {
    Data : [
        {
          Id: 1,
          key:1,
          ExpenseID: "EXP-148061",
          Reference: "#25689825",
          Amount: "$1,54,220",
          Attachment: Expenses1,
          Payment: "Cash",
          Notes: "Lorem ipsum dolor sit consectetur",
          Status: "Paid",
          Action: ""
        },
        {
          Id: 2,
          key:2,
          ExpenseID: "EXP-148062",
          Reference: "#25689826",
          Amount: "$1,222",
          Attachment: Expenses1,
          Payment: "Cheque",
          Notes: "Lorem ipsum dolor sit consectetur",
          Status: "Pending",
          Action: ""
        },
        {
          Id: 3,
          key:3,
          ExpenseID: "EXP-148063",
          Reference: "#25689827",
          Amount: "$2,2222",
          Attachment: Expenses1,
          Payment: "Cheque",
          Notes: "Lorem ipsum dolor sit consectetur",
          Status: "Cancelled",
          Action: ""
        },
        {
          Id: 4,
          key:4,
          ExpenseID: "EXP-148064",
          Reference: "#25689828",
          Amount: "$5,222",
          Attachment: Expenses1,
          Payment: "Cash",
          Notes: "Lorem ipsum dolor sit consectetur",
          Status: "Pending",
          Action: ""
        },
        {
          Id: 5,
          key:5,
          ExpenseID: "EXP-148065",
          Reference: "#25689829",
          Amount: "$8,54,220",
          Attachment: Expenses1,
          Payment: "Cheque",
          Notes: "Lorem ipsum dolor sit consectetur",
          Status: "Paid",
          Action: ""
        },
        {
          Id: 6,
          key:6,
          ExpenseID: "EXP-148066",
          Reference: "#25689830",
          Amount: "$3,54,220",
          Attachment: Expenses1,
          Payment: "Cheque",
          Notes: "Lorem ipsum dolor sit consectetur",
          Status: "Paid",
          Action: ""
        },
        {
          Id: 7,
          key:7,
          ExpenseID: "EXP-148067",
          Reference: "#25689831",
          Amount: "$1,54,220",
          Attachment: Expenses1,
          Payment: "Cash",
          Notes: "Lorem ipsum dolor sit consectetur",
          Status: "Paid",
          Action: ""
        },
        {
          Id: 8,
          key:8,
          ExpenseID: "EXP-148067",
          Reference: "#25689832",
          Amount: "$1,222",
          Attachment: Expenses1,
          Payment: "Cheque",
          Notes: "Lorem ipsum dolor sit consectetur",
          Status: "Pending",
          Action: ""
        },
        {
          Id: 9,
          key:9,
          ExpenseID: "EXP-148068",
          Reference: "#25689833",
          Amount: "$2,2222",
          Attachment: Expenses1,
          Payment: "Cheque",
          Notes: "Lorem ipsum dolor sit consectetur",
          Status: "Cancelled",
          Action: ""
        }
       ]
}